import { AUTH_TYPES, EventDetails } from './types';

export const EDIT_WEBHOOK_ROUTE = '/integrations/webhooks/:webhookId/edit';

export const ADDITIONAL_EMAIL_EVENTS = ['triggeredSendEnabled', 'blastSendEnabled'];

export const ENABLED_WEBHOOK = { label: 'Enabled', value: 'enabled', dataTest: 'status-enabled' };
export const DISABLED_WEBHOOK = {
  label: 'Disabled',
  value: 'disabled',
  dataTest: 'status-disabled',
};

export const WEBHOOK_STATUS_OPTIONS = [ENABLED_WEBHOOK, DISABLED_WEBHOOK];

export const AUTHENTICATION_OPTIONS = Object.values(AUTH_TYPES).map((value) => {
  return {
    value,
    label: value === AUTH_TYPES.NO_AUTH ? 'None' : value,
    dataTest: `webhook-authentication-${value}`,
  };
});

export const ENDPOINT_HELP_TEXT = '{{#urlEncode}}{{myParam}}{{/urlEncode}}';

export const EMAIL_TRIGGER_EVENTS = {
  blastSendEnabled: 'Blast send',
  triggeredSendEnabled: 'Triggered send',
  emailClick: 'Click',
  emailOpen: 'Open',
  emailSubscribe: 'Subscribe',
  emailUnSubscribe: 'Unsubscribe',
  hostedUnsubscribeClick: 'Hosted unsubscribe',
  emailBounce: 'Bounce',
  emailComplaint: 'Complaint',
  emailSendSkip: 'Send skip',
};

export const EMBEDDED_TRIGGER_EVENTS = {
  embeddedClick: 'Click',
  embeddedImpression: 'Impression',
  embeddedReceived: 'Received',
  embeddedSession: 'Session',
};

export const SMS_TRIGGER_EVENTS = {
  smsSend: 'Send',
  smsClick: 'Click',
  smsReceived: 'Received',
  smsBounce: 'Bounce',
  smsSendSkip: 'Send skip',
};

export const SMS_TRIGGER_EVENTS_WITHOUT_CLICK = {
  smsSend: 'Send',
  smsReceived: 'Received',
  smsBounce: 'Bounce',
  smsSendSkip: 'Send skip',
};

export const PUSH_TRIGGER_EVENTS = {
  pushSend: 'Send',
  pushOpen: 'Open',
  pushBounce: 'Bounce',
  pushUninstall: 'Uninstall',
  pushSendSkip: 'Send skip',
};

export const IN_APP_TRIGGER_EVENTS = {
  inAppClick: 'Click',
  inAppClose: 'Close',
  inAppDelete: 'Delete',
  inAppDelivery: 'Delivery',
  inAppOpen: 'Open',
  inAppRecall: 'Recall',
  inAppSend: 'Send',
  inAppSendSkip: 'Send skip',
};

export const WEB_PUSH_TRIGGER_EVENTS = {
  webPushSend: 'Send',
  webPushClick: 'Click',
  webPushSendSkip: 'Send skip',
};

export const WHATS_APP_TRIGGER_EVENTS = {
  whatsAppSend: 'Send',
  whatsAppSendSkip: 'Send skip',
  whatsAppBounce: 'Bounce',
  whatsAppReceived: 'Received',
};

export const WHATS_APP_TRIGGER_EVENTS_GA = {
  ...WHATS_APP_TRIGGER_EVENTS,
  whatsAppSeen: 'Seen',
  whatsAppClick: 'Click',
};

export const OTHER_TRIGGER_EVENTS = {
  anonSession: 'Anonymous Session',
  journeyExit: 'Journey exit',
};

export const EVENT_TYPES_LOOKUP: Record<string, EventDetails> = {
  email: { text: 'Email', events: EMAIL_TRIGGER_EVENTS, requiredFeatureFlags: [] },
  embedded: {
    text: 'Embedded',
    events: EMBEDDED_TRIGGER_EVENTS,
    requiredFeatureFlags: ['EmbeddedMessagingCore'],
  },
  inApp: { text: 'In-app', events: IN_APP_TRIGGER_EVENTS, requiredFeatureFlags: [] },
  push: { text: 'Push', events: PUSH_TRIGGER_EVENTS, requiredFeatureFlags: [] },
  sms: {
    text: 'SMS',
    events: SMS_TRIGGER_EVENTS,
    requiredFeatureFlags: [],
    requiredFeatureFlagsByEvent: {
      smsClick: ['SMSClickWebhookUI'],
    },
  },
  webPush: { text: 'Web Push', events: WEB_PUSH_TRIGGER_EVENTS, requiredFeatureFlags: [] },
  whatsApp: {
    text: 'WhatsApp',
    events: WHATS_APP_TRIGGER_EVENTS,
    requiredFeatureFlags: ['WhatsAppMessageChannel', 'WhatsAppMessageChannelGA'],
    requireOnlyOneFlag: true,
  },
  others: {
    text: 'Others',
    events: OTHER_TRIGGER_EVENTS,
    requiredFeatureFlags: [],
    requiredFeatureFlagsByEvent: {
      anonSession: ['AnonymousUserCriteria'],
      journeyExit: ['InProgressTotalPublishedView'],
    },
  },
};

export const EVENT_TYPES = Object.keys(EVENT_TYPES_LOOKUP);

export const WEBHOOK_ERRORS = {
  MISSING_URL: 'Missing endpoint url',
  INVALID_URL: 'Invalid endpoint url',
  REQUIRES_TOKEN: 'Requires auth token',
  EMPTY_HEADER_FIELD: 'HTTP header field cannot be empty',
};
